import { setShelterName, setEntryKubun } from './actions';

//個人情報取得
const getEntryKubun = () => {
  return async(dispatch, getState) => {
    let state = getState();
    return state.infoaddSelect.entryKubun;
  };
};

//避難所名セット
const setEntryKubunOperation = (value) => {
  return async (dispatch, getState) => {
    
    console.log(value);

    dispatch(setEntryKubun(value));
  };
};

//避難所名セット
const setShelterNameOperation = (value) => {
  return async (dispatch, getState) => {
    
    console.log(value);

    dispatch(setShelterName(value));
  };
};

export default {
  setEntryKubunOperation,
  setShelterNameOperation,
  getEntryKubun
};
